/* ***************************************************************** */
/* TODO: eslint pre-existing exceptions auto generated on 2022-09-08 */
/*       Do not add to these rule exceptions. Only remove as the     */
/*       violations are cleaned from our code.                       */
/*                                                                   */
/*       eslint-disable default-param-last                           */
/*       eslint-disable no-case-declarations                         */
/* ***************************************************************** */
import {
  LOAD_PRODUCTIVITY_FOR_GROWER_BEGIN,
  LOAD_PRODUCTIVITY_FOR_GROWER_END,
  LOAD_PRODUCTIVITY_FOR_GROWER_ERROR,
  SET_APPROVAL_BEGIN,
} from '../actions/productivity';

const initialState = {
  isLoading: false,
  error: null,
  fields: [],
};

export default function productivity(state = initialState, action) {
  switch (action.type) {
    case LOAD_PRODUCTIVITY_FOR_GROWER_BEGIN:
      return {
        isLoading: true,
        error: null,
        fields: [],
      };
    case LOAD_PRODUCTIVITY_FOR_GROWER_END:
      return {
        isLoading: false,
        error: null,
        fields: action.data,
      };
    case LOAD_PRODUCTIVITY_FOR_GROWER_ERROR:
      return {
        isLoading: false,
        error: action.error,
        fields: [],
      };
    case SET_APPROVAL_BEGIN:
      const idx = state.fields.findIndex(
        (f) => f.objectId === action.field.objectId,
      );
      const updatedField = { ...action.field, isApproved: action.isApproved };

      return {
        ...state,
        fields: [
          ...state.fields.slice(0, idx),
          updatedField,
          ...state.fields.slice(idx + 1),
        ],
      };
    default:
      return state;
  }
}
